import navBar from "./navBar"

export const NavBar = navBar